export const DELIMITER = '-{/./:}-' as const;
export const SEPARATOR = '.' as const;
